// extracted by mini-css-extract-plugin
export default {"blockContainer":"BlockStyles_blockContainer__xhpph","flexBox":"BlockStyles_flexBox__c89Xe","dots":"BlockStyles_dots__gMSWT","viewAllLink":"BlockStyles_viewAllLink__+9wgz"};